// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Roboto-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 100;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 300;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 400;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 500;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 700;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: "Roboto";
  font-weight: 900;
  font-style: italic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@keyframes dropdownIn {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.signUpFormHeader {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.4rem 0 0.9rem;
  padding: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: #222;
  text-align: left;
}
.signUpFormHeader svg {
  flex-shrink: 0;
  color: #515592;
}

.signUpForm {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  margin: 0 auto 0.75rem;
  padding: 1.35rem;
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
}
.signUpForm * {
  box-sizing: border-box;
}
.signUpForm .form-group {
  display: flex;
  flex-direction: column;
}
.signUpForm .form-group label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0.45rem;
  font-weight: 500;
  font-size: 0.95rem;
  color: #555;
}
.signUpForm .form-group label svg {
  flex-shrink: 0;
  color: #515592;
  opacity: 0.7;
}
.signUpForm .form-group input {
  width: 100%;
  height: 3.25rem;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.75rem;
  transition: all 0.2s ease;
}
.signUpForm .form-group input:focus {
  outline: none;
  border-color: #515592;
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.1);
}
.signUpForm .form-control {
  width: 100%;
  height: 3.25rem;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.75rem;
  transition: all 0.2s ease;
}
.signUpForm .form-control:focus {
  outline: none;
  border-color: #515592;
  background-color: #ffffff;
  box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.1);
}
.signUpForm input.error,
.signUpForm .form-control.error {
  border-color: #f70d1a;
  background-color: rgba(247, 13, 26, 0.05);
}
.signUpForm input.error::placeholder,
.signUpForm .form-control.error::placeholder {
  color: #f70d1a;
  opacity: 1;
}
.signUpForm input.error:focus,
.signUpForm .form-control.error:focus {
  border-color: #f70d1a;
  box-shadow: 0 0 0 4px rgba(247, 13, 26, 0.1);
}
.signUpForm .phone-input-wrap {
  position: relative;
}
.signUpForm .phone-input-placeholder {
  position: absolute;
  top: 1px;
  right: 1.5px;
  bottom: 1px;
  left: 3.5rem;
  z-index: 11;
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 0 0.75rem 0.75rem 0;
  color: #999;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: none;
}
.signUpForm .phone-input-placeholder.error {
  background-color: #fdf1f1;
  color: #f70d1a;
  font-size: 0.85rem;
}
.signUpForm .error-message {
  margin-top: 0.4rem;
  color: #f70d1a;
  font-size: 0.85rem;
}
.signUpForm .agreementGroup {
  display: flex;
  flex-direction: column;
  padding-left: 0.6rem;
}
.signUpForm .agreementGroup .agreementLabel {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.6rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.signUpForm .agreementGroup .agreementLabel input[type=checkbox] {
  position: absolute;
  width: 1.15rem;
  height: 1.15rem;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}
.signUpForm .agreementGroup .agreementLabel input[type=checkbox]:checked ~ .agreementCheckmark {
  background-color: #515592;
  border-color: #515592;
}
.signUpForm .agreementGroup .agreementLabel input[type=checkbox]:checked ~ .agreementCheckmark::after {
  opacity: 1;
  transform: rotate(45deg) scale(1);
}
.signUpForm .agreementGroup .agreementLabel input[type=checkbox]:focus-visible ~ .agreementCheckmark {
  box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.2);
}
.signUpForm .agreementGroup .agreementLabel .agreementCheckmark {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.15rem;
  height: 1.15rem;
  background-color: #f9f9f9;
  border: 1.5px solid #ddd;
  border-radius: 0.35rem;
  transition: all 0.15s ease;
}
.signUpForm .agreementGroup .agreementLabel .agreementCheckmark::after {
  content: "";
  width: 0.3rem;
  height: 0.55rem;
  margin-top: -0.08rem;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  opacity: 0;
  transform: rotate(45deg) scale(0.6);
  transition: all 0.15s ease;
}
.signUpForm .agreementGroup .agreementLabel .agreementText {
  font-size: 0.85rem;
  line-height: 1.4;
  color: #555;
}
.signUpForm .agreementGroup .agreementLabel .agreementText a {
  color: #515592;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.signUpForm .agreementGroup .agreementLabel .agreementText a:hover {
  color: #3f4373;
}
.signUpForm .phone-input .form-control {
  width: 100%;
  height: 3.25rem !important;
  border-radius: 0.75rem !important;
  padding-left: 3.5rem !important;
}
.signUpForm .phone-input .flag-dropdown {
  padding-left: 0.5rem;
  background: transparent !important;
  border: none !important;
  border-radius: 0.75rem 0 0 0.75rem !important;
}
.signUpForm .phone-input .flag-dropdown .selected-flag {
  border-radius: 0.75rem 0 0 0.75rem;
}
.signUpForm .phone-input .flag-dropdown .selected-flag:hover, .signUpForm .phone-input .flag-dropdown .selected-flag:focus {
  background-color: transparent;
}
.signUpForm .phone-input .country-list {
  top: calc(100% + 0.5rem);
  left: 0;
  width: 320px;
  max-width: calc(100vw - 3rem);
  max-height: 260px;
  padding: 0.5rem;
  background-color: #ffffff;
  border: 1px solid #eee;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  z-index: 20;
  animation: dropdownIn 0.18s cubic-bezier(0.16, 1, 0.3, 1);
}
.signUpForm .phone-input .country-list::-webkit-scrollbar {
  width: 6px;
}
.signUpForm .phone-input .country-list::-webkit-scrollbar-track {
  background: transparent;
}
.signUpForm .phone-input .country-list::-webkit-scrollbar-thumb {
  background-color: rgba(81, 85, 146, 0.25);
  border-radius: 10px;
}
.signUpForm .phone-input .country-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(81, 85, 146, 0.4);
}
.signUpForm .phone-input .country-list .search {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.5rem 0.75rem;
  background-color: #ffffff;
}
.signUpForm .phone-input .country-list .search .search-box {
  width: 100%;
  margin: 0;
  padding: 0.6rem 0.9rem;
  font-size: 0.9rem;
  background-color: #f9f9f9;
  border: 1.5px solid #eee;
  border-radius: 0.6rem;
  transition: all 0.2s ease;
}
.signUpForm .phone-input .country-list .search .search-box:focus {
  outline: none;
  border-color: #515592;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.1);
}
.signUpForm .phone-input .country-list .country {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.75rem;
  border-radius: 0.6rem;
  transition: background-color 0.15s ease;
}
.signUpForm .phone-input .country-list .country .flag {
  margin-right: 0.75rem;
  flex-shrink: 0;
}
.signUpForm .phone-input .country-list .country .country-name {
  color: #333;
  font-size: 0.95rem;
}
.signUpForm .phone-input .country-list .country .dial-code {
  margin-left: 0.4rem;
  color: #999;
  font-size: 0.9rem;
}
.signUpForm .phone-input .country-list .country:hover {
  background-color: rgba(81, 85, 146, 0.08);
}
.signUpForm .phone-input .country-list .country.highlight {
  background-color: rgba(81, 85, 146, 0.12);
}
.signUpForm .phone-input .country-list .country.highlight .country-name {
  font-weight: 500;
  color: #515592;
}
.signUpForm .phone-input .country-list .divider {
  margin: 0.4rem 0.25rem;
  border-bottom: 1px solid #f0f0f0;
}
.signUpForm .phone-input .country-list .no-entries-message {
  padding: 0.75rem;
  color: #999;
  font-size: 0.9rem;
  text-align: center;
}
.signUpForm button {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 3rem);
  background: linear-gradient(to right, #1d2239, #4657a2, #1d2239);
  color: #ffffff;
  border-radius: 2rem;
  border: none;
  text-transform: uppercase;
  font-size: 1.1rem;
  line-height: 1.3rem;
  padding: 1rem 0;
  margin: 1rem 1.5rem;
}
.signUpForm button:active:not(:disabled) {
  box-shadow: 0 0.125rem 0.5rem #363c56;
  transform: translateY(0.125rem);
  opacity: 0.75;
}
.signUpForm button:disabled {
  background: rgb(200, 200, 200);
}
.signUpForm button {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  width: 100%;
  max-width: 200px;
  height: 3rem;
  margin-top: 0;
  padding: 0;
  background: #515592 !important;
  color: #ffffff;
  font-weight: 500 !important;
  font-size: 1.1rem;
  letter-spacing: 0.2px;
  border: none;
  border-radius: 100px;
  box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: none !important;
}
.signUpForm button:hover {
  filter: brightness(1.05);
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);
}
.signUpForm button:active {
  filter: brightness(0.95);
  transform: translateY(1px);
  box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);
}
.signUpForm button:disabled {
  background: rgb(200, 200, 200) !important;
  box-shadow: none;
  cursor: not-allowed;
}

.signUpBottomLink {
  margin-top: 0.6rem;
  text-align: center;
  color: #777777;
  font-size: 0.9rem;
}
.signUpBottomLink a {
  padding: 0.2rem 0.5rem;
  color: #515592;
  font-weight: 600;
  text-decoration: none;
  border-radius: 0.4rem;
  transition: background 0.2s;
}
.signUpBottomLink a:hover {
  background: rgba(81, 85, 146, 0.1);
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/Theme/variables/_fonts.scss","webpack://./src/components/SignUpForm/SignUpForm.scss","webpack://./src/assets/Theme/variables/_colorSchema.scss","webpack://./src/assets/Theme/mixins/_app-button.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACCF;ADEA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACAF;ADGA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACDF;ADIA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACFF;ADKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACHF;ADMA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACJF;ADOA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACLF;ADQA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACNF;ADSA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACPF;ADUA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+DAAA;ACRF;ADWA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACTF;ADYA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gEAAA;ACVF;AAnEA;EACE;IACE,UAAA;IACA,uCAAA;EAqEF;EAnEA;IACE,UAAA;IACA,iCAAA;EAqEF;AACF;AAlEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AAoEF;AAlEE;EACE,cAAA;EACA,cA1BY;AA8FhB;;AAhEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBCtCM;EDuCN,mBAAA;EACA,2CAAA;EACA,sBAAA;AAmEF;AAjEE;EACE,sBAAA;AAmEJ;AAhEE;EACE,aAAA;EACA,sBAAA;AAkEJ;AAhEI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAkEN;AAhEM;EACE,cAAA;EACA,cA5DQ;EA6DR,YAAA;AAkER;AA9DI;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;AAgEN;AA9DM;EACE,aAAA;EACA,qBA7EQ;EA8ER,yBChFA;EDiFA,4CAAA;AAgER;AA3DE;EACE,WAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,yBAAA;AA6DJ;AA3DI;EACE,aAAA;EACA,qBAhGU;EAiGV,yBCnGE;EDoGF,4CAAA;AA6DN;AAzDE;;EAEE,qBCtGQ;EDuGR,yCAAA;AA2DJ;AAzDI;;EACE,cC1GM;ED2GN,UAAA;AA4DN;AAzDI;;EACE,qBC/GM;EDgHN,4CAAA;AA4DN;AAxDE;EACE,kBAAA;AA0DJ;AAvDE;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;AAyDJ;AAvDI;EACE,yBAAA;EACA,cC5IM;ED6IN,kBAAA;AAyDN;AArDE;EACE,kBAAA;EACA,cCnJQ;EDoJR,kBAAA;AAuDJ;AApDE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAsDJ;AApDI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAsDN;AApDM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAsDR;AApDQ;EACE,yBA/KM;EAgLN,qBAhLM;AAsOhB;AApDU;EACE,UAAA;EACA,iCAAA;AAsDZ;AAlDQ;EACE,4CAAA;AAoDV;AAhDM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,0BAAA;AAkDR;AAhDQ;EACE,WAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;EACA,mCAAA;EACA,0BAAA;AAkDV;AA9CM;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AAgDR;AA9CQ;EACE,cA5NM;EA6NN,gBAAA;EACA,0BAAA;EACA,0BAAA;AAgDV;AA9CU;EACE,cAAA;AAgDZ;AAxCI;EACE,WAAA;EACA,0BAAA;EACA,iCAAA;EACA,+BAAA;AA0CN;AAvCI;EACE,oBAAA;EACA,kCAAA;EACA,uBAAA;EACA,6CAAA;AAyCN;AAvCM;EACE,kCAAA;AAyCR;AAvCQ;EAEE,6BAAA;AAwCV;AAnCI;EACE,wBAAA;EACA,OAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;EACA,yBC1QE;ED2QF,sBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,WAAA;EACA,yDAAA;AAqCN;AAnCM;EACE,UAAA;AAqCR;AAlCM;EACE,uBAAA;AAoCR;AAjCM;EACE,yCAAA;EACA,mBAAA;AAmCR;AAjCQ;EACE,wCAAA;AAmCV;AA/BM;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,8BAAA;EACA,yBCxSA;ADyUR;AA/BQ;EACE,WAAA;EACA,SAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yBAAA;AAiCV;AA/BU;EACE,aAAA;EACA,qBApTI;EAqTJ,yBCvTJ;EDwTI,4CAAA;AAiCZ;AA5BM;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,qBAAA;EACA,uCAAA;AA8BR;AA5BQ;EACE,qBAAA;EACA,cAAA;AA8BV;AA3BQ;EACE,WAAA;EACA,kBAAA;AA6BV;AA1BQ;EACE,mBAAA;EACA,WAAA;EACA,iBAAA;AA4BV;AAzBQ;EACE,yCAAA;AA2BV;AAxBQ;EACE,yCAAA;AA0BV;AAxBU;EACE,gBAAA;EACA,cA3VI;AAqXhB;AArBM;EACE,sBAAA;EACA,gCAAA;AAuBR;AApBM;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAsBR;AAjBE;EE/WA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gEDDe;ECEf,cDPM;ECQN,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AFmYF;AElYE;EACE,qCAAA;EACA,+BAAA;EACA,aAAA;AFoYJ;AElYE;EACE,8BDdO;ADkZX;AAvCI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,8BAAA;EACA,cC7XE;ED8XF,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,YAAA;EACA,oBAAA;EACA,8CAAA;EACA,eAAA;EACA,yBAAA;EACA,+BAAA;AAyCN;AAvCM;EACE,wBAAA;EACA,2BAAA;EACA,8CAAA;AAyCR;AAtCM;EACE,wBAAA;EACA,0BAAA;EACA,6CAAA;AAwCR;AArCM;EACE,yCAAA;EACA,gBAAA;EACA,mBAAA;AAuCR;;AAjCA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAoCF;AAlCE;EACE,sBAAA;EACA,cAnaY;EAoaZ,gBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2BAAA;AAoCJ;AAlCI;EACE,kCAAA;EACA,qBAAA;AAoCN","sourcesContent":["@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Thin.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 100;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-ThinItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 300;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-LightItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 400;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Medium.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 500;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-MediumItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 700;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: normal;\n  src: url('../../../assets/fonts/Roboto-Black.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'Roboto';\n  font-weight: 900;\n  font-style: italic;\n  src: url('../../../assets/fonts/Roboto-BlackItalic.ttf') format('truetype');\n}\n","@import '../../assets/Theme';\n\n$brand_primary: #515592;\n\n@keyframes dropdownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.signUpFormHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0.4rem 0 0.9rem;\n  padding: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #222;\n  text-align: left;\n\n  svg {\n    flex-shrink: 0;\n    color: $brand_primary;\n  }\n}\n\n.signUpForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n  margin: 0 auto 0.75rem;\n  padding: 1.35rem;\n  background-color: $white;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n  box-sizing: border-box;\n\n  * {\n    box-sizing: border-box;\n  }\n\n  .form-group {\n    display: flex;\n    flex-direction: column;\n\n    label {\n      display: flex;\n      align-items: center;\n      gap: 0.4rem;\n      margin-bottom: 0.45rem;\n      font-weight: 500;\n      font-size: 0.95rem;\n      color: #555;\n\n      svg {\n        flex-shrink: 0;\n        color: $brand_primary;\n        opacity: 0.7;\n      }\n    }\n\n    input {\n      width: 100%;\n      height: 3.25rem;\n      padding: 0.75rem 1rem;\n      font-size: 1rem;\n      background-color: #f9f9f9;\n      border: 1.5px solid #eee;\n      border-radius: 0.75rem;\n      transition: all 0.2s ease;\n\n      &:focus {\n        outline: none;\n        border-color: $brand_primary;\n        background-color: $white;\n        box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.1);\n      }\n    }\n  }\n\n  .form-control {\n    width: 100%;\n    height: 3.25rem;\n    padding: 0.75rem 1rem;\n    font-size: 1rem;\n    background-color: #f9f9f9;\n    border: 1.5px solid #eee;\n    border-radius: 0.75rem;\n    transition: all 0.2s ease;\n\n    &:focus {\n      outline: none;\n      border-color: $brand_primary;\n      background-color: $white;\n      box-shadow: 0 0 0 4px rgba(81, 85, 146, 0.1);\n    }\n  }\n\n  input.error,\n  .form-control.error {\n    border-color: $errorText;\n    background-color: rgba($errorText, 0.05);\n\n    &::placeholder {\n      color: $errorText;\n      opacity: 1;\n    }\n\n    &:focus {\n      border-color: $errorText;\n      box-shadow: 0 0 0 4px rgba($errorText, 0.1);\n    }\n  }\n\n  .phone-input-wrap {\n    position: relative;\n  }\n\n  .phone-input-placeholder {\n    position: absolute;\n    top: 1px;\n    right: 1.5px;\n    bottom: 1px;\n    left: 3.5rem;\n    z-index: 11;\n    display: flex;\n    align-items: center;\n    background-color: #f9f9f9;\n    border-radius: 0 0.75rem 0.75rem 0;\n    color: #999;\n    font-size: 1rem;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    pointer-events: none;\n\n    &.error {\n      background-color: #fdf1f1;\n      color: $errorText;\n      font-size: 0.85rem;\n    }\n  }\n\n  .error-message {\n    margin-top: 0.4rem;\n    color: $errorText;\n    font-size: 0.85rem;\n  }\n\n  .agreementGroup {\n    display: flex;\n    flex-direction: column;\n    padding-left: 0.6rem;\n\n    .agreementLabel {\n      position: relative;\n      display: flex;\n      align-items: center;\n      gap: 0.6rem;\n      cursor: pointer;\n      user-select: none;\n\n      input[type='checkbox'] {\n        position: absolute;\n        width: 1.15rem;\n        height: 1.15rem;\n        margin: 0;\n        opacity: 0;\n        cursor: pointer;\n\n        &:checked ~ .agreementCheckmark {\n          background-color: $brand_primary;\n          border-color: $brand_primary;\n\n          &::after {\n            opacity: 1;\n            transform: rotate(45deg) scale(1);\n          }\n        }\n\n        &:focus-visible ~ .agreementCheckmark {\n          box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.2);\n        }\n      }\n\n      .agreementCheckmark {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        width: 1.15rem;\n        height: 1.15rem;\n        background-color: #f9f9f9;\n        border: 1.5px solid #ddd;\n        border-radius: 0.35rem;\n        transition: all 0.15s ease;\n\n        &::after {\n          content: '';\n          width: 0.3rem;\n          height: 0.55rem;\n          margin-top: -0.08rem;\n          border: solid $white;\n          border-width: 0 2px 2px 0;\n          opacity: 0;\n          transform: rotate(45deg) scale(0.6);\n          transition: all 0.15s ease;\n        }\n      }\n\n      .agreementText {\n        font-size: 0.85rem;\n        line-height: 1.4;\n        color: #555;\n\n        a {\n          color: $brand_primary;\n          font-weight: 600;\n          text-decoration: underline;\n          text-underline-offset: 2px;\n\n          &:hover {\n            color: #3f4373;\n          }\n        }\n      }\n    }\n  }\n\n  .phone-input {\n    .form-control {\n      width: 100%;\n      height: 3.25rem !important;\n      border-radius: 0.75rem !important;\n      padding-left: 3.5rem !important;\n    }\n\n    .flag-dropdown {\n      padding-left: 0.5rem;\n      background: transparent !important;\n      border: none !important;\n      border-radius: 0.75rem 0 0 0.75rem !important;\n\n      .selected-flag {\n        border-radius: 0.75rem 0 0 0.75rem;\n\n        &:hover,\n        &:focus {\n          background-color: transparent;\n        }\n      }\n    }\n\n    .country-list {\n      top: calc(100% + 0.5rem);\n      left: 0;\n      width: 320px;\n      max-width: calc(100vw - 3rem);\n      max-height: 260px;\n      padding: 0.5rem;\n      background-color: $white;\n      border: 1px solid #eee;\n      border-radius: 1rem;\n      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);\n      overflow-y: auto;\n      z-index: 20;\n      animation: dropdownIn 0.18s cubic-bezier(0.16, 1, 0.3, 1);\n\n      &::-webkit-scrollbar {\n        width: 6px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: transparent;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: rgba(81, 85, 146, 0.25);\n        border-radius: 10px;\n\n        &:hover {\n          background-color: rgba(81, 85, 146, 0.4);\n        }\n      }\n\n      .search {\n        position: sticky;\n        top: 0;\n        z-index: 1;\n        padding: 0.5rem 0.5rem 0.75rem;\n        background-color: $white;\n\n        .search-box {\n          width: 100%;\n          margin: 0;\n          padding: 0.6rem 0.9rem;\n          font-size: 0.9rem;\n          background-color: #f9f9f9;\n          border: 1.5px solid #eee;\n          border-radius: 0.6rem;\n          transition: all 0.2s ease;\n\n          &:focus {\n            outline: none;\n            border-color: $brand_primary;\n            background-color: $white;\n            box-shadow: 0 0 0 3px rgba(81, 85, 146, 0.1);\n          }\n        }\n      }\n\n      .country {\n        display: flex;\n        align-items: center;\n        padding: 0.65rem 0.75rem;\n        border-radius: 0.6rem;\n        transition: background-color 0.15s ease;\n\n        .flag {\n          margin-right: 0.75rem;\n          flex-shrink: 0;\n        }\n\n        .country-name {\n          color: #333;\n          font-size: 0.95rem;\n        }\n\n        .dial-code {\n          margin-left: 0.4rem;\n          color: #999;\n          font-size: 0.9rem;\n        }\n\n        &:hover {\n          background-color: rgba(81, 85, 146, 0.08);\n        }\n\n        &.highlight {\n          background-color: rgba(81, 85, 146, 0.12);\n\n          .country-name {\n            font-weight: 500;\n            color: $brand_primary;\n          }\n        }\n      }\n\n      .divider {\n        margin: 0.4rem 0.25rem;\n        border-bottom: 1px solid #f0f0f0;\n      }\n\n      .no-entries-message {\n        padding: 0.75rem;\n        color: #999;\n        font-size: 0.9rem;\n        text-align: center;\n      }\n    }\n  }\n\n  button {\n    @include app-button;\n    & {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      align-self: center;\n      width: 100%;\n      max-width: 200px;\n      height: 3rem;\n      margin-top: 0;\n      padding: 0;\n      background: $brand_primary !important;\n      color: $white;\n      font-weight: 500 !important;\n      font-size: 1.1rem;\n      letter-spacing: 0.2px;\n      border: none;\n      border-radius: 100px;\n      box-shadow: 0 6px 20px rgba(81, 85, 146, 0.35);\n      cursor: pointer;\n      transition: all 0.3s ease;\n      text-transform: none !important;\n\n      &:hover {\n        filter: brightness(1.05);\n        transform: translateY(-1px);\n        box-shadow: 0 8px 25px rgba(81, 85, 146, 0.45);\n      }\n\n      &:active {\n        filter: brightness(0.95);\n        transform: translateY(1px);\n        box-shadow: 0 3px 10px rgba(81, 85, 146, 0.2);\n      }\n\n      &:disabled {\n        background: $disabled !important;\n        box-shadow: none;\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\n.signUpBottomLink {\n  margin-top: 0.6rem;\n  text-align: center;\n  color: #777777;\n  font-size: 0.9rem;\n\n  a {\n    padding: 0.2rem 0.5rem;\n    color: $brand_primary;\n    font-weight: 600;\n    text-decoration: none;\n    border-radius: 0.4rem;\n    transition: background 0.2s;\n\n    &:hover {\n      background: rgba(81, 85, 146, 0.1);\n      text-decoration: none;\n    }\n  }\n}","$white: #ffffff;\n$text_dark: #2c2c2e;\n$text_gray: rgb(178, 181, 188);\n$buttonBg: #363c56;\n$errorText: #f70d1a;\n$buttonLinearBg: linear-gradient(to right, #1d2239, #4657a2, #1d2239);\n$msgDisable: rgb(150, 150, 150);\n$disabled: rgb(200, 200, 200);\n$light_gray: rgb(241, 241, 241);\n$unselectedText: rgb(80, 80, 80);\n$locationBnt: rgb(255, 255, 0);\n$spinner_blue: #3498db;\n\n$bg_unselected: rgb(188, 188, 224);\n$bg_selected: #559f5b;\n$bg_pending: #ccb137;\n$bg_frame: rgba(0, 0, 0, 0.6);\n\n$shadow: #2c2c2e5e;\n$light_shadow: rgba(49, 49, 52, 0.2);\n$highlighter: #eeff6e;\n$appt_bg: rgb(249, 249, 249);\n$red_bg: #cb101a;\n\n$notification_success: #4fae00;\n$notification_warning: #e4dd00;\n$notification_error: #be1000;\n","@mixin app-button() {\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: calc(100% - 3rem);\n  background: $buttonLinearBg;\n  color: $white;\n  border-radius: 2rem;\n  border: none;\n  text-transform: uppercase;\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n  padding: 1rem 0;\n  margin: 1rem 1.5rem;\n  &:active:not(:disabled) {\n    box-shadow: 0 0.125rem 0.5rem $buttonBg;\n    transform: translateY(0.125rem);\n    opacity: 0.75;\n  }\n  &:disabled {\n    background: $disabled;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
